import { TabbedShowLayout, TextField, useGetIdentity, useGetOne, useRecordContext, useTranslate } from "react-admin"
import TextModelFields from "../textModel/TextModelFields"
import textModelTemplate from "../fixtures/textModelTemplate"
import CustomerStatistic from "./CustomerStatistic"

const CustomerShowLayout = () => {
  const translate = useTranslate()
  const { data: identity, isLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id})
  const record = useRecordContext()

  if(isLoading || !identity || userLoading || !record) return null

  const textRecord = record?.textModel ? record : (user.textModel ? {...record, textModel: user.textModel} : {...record, textModel: textModelTemplate})

  return (
    <TabbedShowLayout record={textRecord}>
      <TabbedShowLayout.Tab label="resources.company.name">
        <TextField source="company.companyName" label="resources.company.companyName" emptyText='-' />
        <TextField source="company.street" label="resources.company.street" emptyText='-' />
        <TextField source="company.postCode" label="resources.company.postCode" emptyText='-' />
        <TextField source="company.city" label="resources.company.city" emptyText='-' />
        <TextField source="company.country" label="resources.company.country" emptyText='-' />
        <TextField source="company.email" label="resources.company.email" emptyText='-' />
        <TextField source="ustId" label="resources.customers.ustId" emptyText='-' />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label={translate("resources.textTemplates.name", {smart_count: 2})}>
        {TextModelFields(user.isSmallBusiness)}
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label={translate("resources.customers.statistic.name", {smart_count: 2})}>
        <CustomerStatistic />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  )
}

export default CustomerShowLayout